Vendd.Scripts.load(function () {

    var currentRecipeItems = [];

    var configuratorOptions = {};
    /**
     * HasAuthorizedPage                if true, user must be logged in to see configurator or uri must have valid global identifier (GlobalId)
     * LoadFromDatabase                 if true, then configurator can load the product recipe item list from database with a valid global identifier
     * SaveToDatabase                   if true, then configurator can save the product recipe item list to database and generate a global identifier
     * HasSummaryPage                   if configurator has a summary page of standard items, optional items and prices
     * HasQuantitySelectors             if product recipe items have quantity selector (true) or have just checked buttons (false)
     * SaveToLocalStorage               if true, then on changing the recipe item list, this list will be save to local storage
     * OnLoadPageLoadFromLocalStorage             if true, then on loading the configurator, the recipe item list will be load from local storage
     * 
     * */

    /**
     * ----------------------
     * --PIZZA HUT OPTIONS---
     * ----------------------
    options.HasAuthorizedPage = false;
    options.LoadFromDatabase = false;
    options.SaveToDatabase = false;
    options.HasSummaryPage = false;
    options.HasQuantitySelectors = true;
    options.SaveToLocalStorage = false;
    options.OnLoadPageLoadFromLocalStorage = false;
     */

    /**
     * ----------------------
     * -----BJT OPTIONS------
     * ----------------------
    options.HasAuthorizedPage = true;
    options.LoadFromDatabase = true;
    options.SaveToDatabase = true;
    options.HasSummaryPage = true;
    options.HasQuantitySelectors = false;
    options.OnLoadPageLoadFromLocalStorage = false;
     */

    (function ($) {
        $.getElement = function (element, $_wrapper) {
            if (!$_wrapper) return $("");
            var _wrapper = $_wrapper.get(0);
            var $items;
            if (_wrapper.config.isSubRecipe) {
                $items = $(element, $_wrapper);
            } else {
                $items = $("");
                $('.x-recipe-ingredients ' + element, $_wrapper).each(function (i, el) {
                    if ($(el).closest('.x-subrecipe').length === 0) {
                        $items.push(el);
                    }
                });
            }
            return $items;
        };
        $.getGlobalElement = function (element, $_wrapper) {
            if (!$_wrapper || $_wrapper.length === 0) return $("");
            var _wrapper = $_wrapper.get(0);
            var $items = $("");
            if (_wrapper.$recipe_container) {
                $(element, _wrapper.$recipe_container).each(function (i, el) {
                    $items.push(el);
                });
            }
            return $items;
        };
    })(jQuery);

    var recipeController = function ($wrapper, options, literals) {
        if ($wrapper.length < 1)
            return;

        var wrapper = $wrapper.get(0);

        var state = Vendd.Product.Controller.getState();
        var id = parseInt($wrapper.attr('data-id') || state.parentId),
            skuId = parseInt($wrapper.attr('data-skuid') || state.selectedId),
            path = state.path,
            qty = state.qty,
            extraAttributes = [],
            bundleItems = state.bundleItems,
            recipeItems = [],
            comboRecipes = [],
            comboItems = state.comboItems;
        wrapper.state = {};
        wrapper.state.id = id;
        wrapper.state.skuId = skuId;
        var current_product_id;

        wrapper.setOptions = function (options) {

            var _defaultConfiguration = {};


            _defaultConfiguration.isSubRecipe = $wrapper.hasClass('issubrecipe');

            _defaultConfiguration.$ParentWrapper = _defaultConfiguration.isSubRecipe ? $wrapper.parents('.x-recipe-ingredients-wrapper') : null;
            _defaultConfiguration.ParentWrapper = _defaultConfiguration.isSubRecipe ? $wrapper.parents('.x-recipe-ingredients-wrapper').get(0) : null;

            _defaultConfiguration.isComboPage = $wrapper.hasClass('combo');
            _defaultConfiguration.isConfigurationPage = $wrapper.hasClass('configuration-page');
            _defaultConfiguration.PartialHtml = $wrapper.attr("data-partialhtml") || "pdRecipeIngredients";
            _defaultConfiguration.isFancyboxPopup = $wrapper.hasClass('configuration-page');
            _defaultConfiguration.ParentRecipeId = _defaultConfiguration.isSubRecipe ? parseInt($wrapper.parents('.x-recipe-ingredients-wrapper').get(0).model.RecipeId) || 0 : 0;
            _defaultConfiguration.ParentRecipeItemId = _defaultConfiguration.isSubRecipe ? parseInt($wrapper.parents('.x-recipe-ingredients-wrapper').get(0).model.RecipeItemId) || 0 : 0;

            _defaultConfiguration.RecipeItemId = wrapper.state.skuId;
            _defaultConfiguration.RecipeId = parseInt($wrapper.attr("data-recipe-id") !== undefined ? $wrapper.attr("data-recipe-id") || 0 : 0);
            _defaultConfiguration.HasAuthorizedPage = $wrapper.attr("data-hasauthorizedpage") !== undefined ? $wrapper.attr("data-hasauthorizedpage") === "true" : false;
            _defaultConfiguration.HasAuthorizedSave = $wrapper.attr("data-hasauthorizedsave") !== undefined ? $wrapper.attr("data-hasauthorizedsave") === "true" : true;
            _defaultConfiguration.LoadFromDatabase = $wrapper.attr("data-loadfromdatabase") !== undefined ? $wrapper.attr('data-loadfromdatabase') === "true" : false;
            _defaultConfiguration.SaveToDatabase = $wrapper.attr("data-savetodatabase") !== undefined ? $wrapper.attr('data-savetodatabase') === "true" : false;
            _defaultConfiguration.ShareConfiguration = $wrapper.attr("data-shareconfiguration") !== undefined ? $wrapper.attr('data-shareconfiguration') === "true" : false;
            _defaultConfiguration.PdfExport = $wrapper.attr("data-pdfexport") !== undefined ? $wrapper.attr('data-pdfexport') === "true" : false;
            _defaultConfiguration.SendToOneDealer = $wrapper.attr("data-onedealer") !== undefined ? $wrapper.attr('data-onedealer') === "true" : false;
            _defaultConfiguration.HasSummaryPage = $wrapper.attr("data-hassummarypage") !== undefined ? $wrapper.attr('data-hassummarypage') === "true" : false;
            _defaultConfiguration.HasQuantitySelectors = $wrapper.attr("data-hasquantityselectors") !== undefined ? $wrapper.attr('data-hasquantityselectors') === "true" : false;
            _defaultConfiguration.SaveToLocalStorage = $wrapper.attr("data-savetolocalstorage") !== undefined ? $wrapper.attr('data-savetolocalstorage') === "true" : false;
            _defaultConfiguration.OnLoadPageLoadFromLocalStorage = $wrapper.attr("data-onloadpageloadfromlocalstorage") !== undefined ? $wrapper.attr("data-onloadpageloadfromlocalstorage") === "true" : false;
            _defaultConfiguration.Attributes = $wrapper.attr("data-attributes") || "";
            _defaultConfiguration.IsPostalCodeMandatory = $wrapper.attr("data-is-postalcode-mandatory") !== undefined ? $wrapper.attr('data-is-postalcode-mandatory') === "true" : false;

            _defaultConfiguration.IsAuthorizedPage = false;

            wrapper.config = $.extend({}, _defaultConfiguration, options || {});
        };

        wrapper.setLiterals = function (literals) {

            wrapper.literals = literals || {};

            //wrapper.literals.title = $wrapper.attr('data-title') || "";
            wrapper.literals.UnAuthorizedText = $wrapper.attr('data-unauthorized-text') || "You first need to log in in order to configure a trailer.Don’t have an account? Register Here! It’s FREE and it takes less than 30 seconds";
            wrapper.literals.UnAuthorizedLoginText1 = $wrapper.attr('data-unauthorized-login-text1') || "LOGIN TO YOUR ACCOUNT ";
            wrapper.literals.UnAuthorizedLoginText2 = $wrapper.attr('data-unauthorized-login-text2') || "You can also create an account here";

            wrapper.literals.InvalidRegistrationData = $wrapper.attr('data-invalid-data') || "INVALID REGISTRATION DATA!";

            wrapper.literals.UnAuthorizedButtonText1 = $wrapper.attr('data-unauthorized-login-text1') || "LOGIN TO YOUR ACCOUNT!";
            wrapper.literals.UnAuthorizedButtonText2 = $wrapper.attr('data-unauthorized-login-text2') || "You can also create account here";

            wrapper.literals.TooltipPrevStep = $wrapper.attr('data-tooltip-prev-step') || "Please go through previous steps";

            wrapper.literals.Standard = $wrapper.attr('data-standard') || "STANDARD";
            wrapper.literals.Optional = $wrapper.attr('data-optional') || "OPTIONAL";
            wrapper.literals.NextStep = $wrapper.attr('data-next-step') || "NEXT STEP";
            wrapper.literals.ShowSummary = $wrapper.attr('data-show-summary') || "SHOW SUMMARY";
            wrapper.literals.SubmitRegistration = $wrapper.attr('data-submit-registration') || "SUBMIT CONFIGURATION";

            wrapper.literals.Summary = $wrapper.attr('data-summary') || "Summary";
            wrapper.literals.BackToConfiguration = $wrapper.attr('data-back-to-configuration') || "BACK TO CONFIGURATION";
            wrapper.literals.SummaryGeneralErrors = $wrapper.attr('data-summary-general-errors') || "GENERAL ERRORS";
            wrapper.literals.SummaryGeneralErrorsDescription = $wrapper.attr('data-summary-general-errors-description') || "Please go <a>back to the configuration page</a> and review the following errors and/or inconsistencies:";
            wrapper.literals.OutdatedEquipment = $wrapper.attr('data-outdated-equipment') || "OUTDATED EQUIPMENT";
            wrapper.literals.StandardEquipment = $wrapper.attr('data-standard-equipment') || "STANDARD EQUIPMENT";
            wrapper.literals.OptionalEquipment = $wrapper.attr('data-optional-equipment') || "OPTIONAL EQUIPMENT";
            wrapper.literals.OptionalEquipmentTotalPrice = $wrapper.attr('data-optional-equipment-total-price') || "Optional equipment total price";

            wrapper.literals.PricesText = $wrapper.attr('data-prices-text') || "PRICES";
            wrapper.literals.StandardPriceText = $wrapper.attr('data-prices-standard-price-text') || "BASIC PRICE";
            wrapper.literals.OptionalPriceText = $wrapper.attr('data-prices-optional-price-text') || "OPTIONAL EQUIPMENT";
            wrapper.literals.ShippingPriceText = $wrapper.attr('data-prices-shipping-price-text') || "DELIVERY IN UK";
            wrapper.literals.TotalPriceText = $wrapper.attr('data-prices-total-price-text') || "TOTAL PRICE";

            wrapper.literals.AvailableText = $wrapper.attr('data-available-text') || "Available direct to your address - 30 days";

            wrapper.literals.ShareText = $wrapper.attr('data-share-text') || "SHARE";
            wrapper.literals.DownloadPdfText = $wrapper.attr('data-download-pdf-text') || "DOWNLOAD PDF";
            wrapper.literals.SaveForLaterText = $wrapper.attr('data-save-for-later-text') || "SAVE FOR LATER";
            wrapper.literals.PricesVatNote = $wrapper.attr('data-price-vat-note') || "All prices excl. 20% VAT";
        };

        wrapper.setOptions(options);

        wrapper.setLiterals(literals);

        wrapper.$recipe_container = wrapper.config.isComboPage ?
            $wrapper.closest('.page_ProductList') :
            wrapper.config.isConfigurationPage ? $wrapper.closest('.recipe-container') : $wrapper.closest('.x-product-details');

        var $versionSelector = $.getGlobalElement('.x-product-details-version-selector', $wrapper);

        var maxQuantity = 0,
            maxFreeQuantity = 0,
            maxedOut = 0,
            maxReplaceQuantity = 0,
            defaultQuantity = 0,
            currentQuantity = 0,
            recipeInitialPrice = parseFloat(stringToNumber($('.current-price').attr('data-price'))),
            comboRecipePrice = 0,
            recipePrice = recipeInitialPrice;
        wrapper.initModel = {}, wrapper.model = {}, shippingModel = {};

        var checkboxChange = function (event) {
            if (this.checked) {
                ifChecked(event);
            } else {
                ifUnchecked(event);
            }
        };

        var ifChecked = function (event) {
            if ($(event.target).hasClass("loading")) return;
            if ($(event.target).hasClass("disabled")) return;
            $(event.target).addClass("loading");
            //var recipeId = id;
            var ingredientId = parseInt(event.target.dataset.ingredientid || "") || -1;
            var quantity = parseFloat(stringToNumber(event.target.dataset.quanta || "1") || 1);

            var result, ingredientIdFrom;
            if ($(event.target).is(":radio")) {
                var radioName = event.target.name;
                var $ingredientIdFrom = $("input[name='" + event.target.name + "'].active");
                //check for None option
                if ($ingredientIdFrom.is(".option-nullable") || $(event.target).is(".option-nullable")) {
                    if ($ingredientIdFrom.is(".option-nullable")) {
                        //if unchecked None option
                        result = Vendd.RecipeLibrary.AddIngredient(wrapper.model, wrapper.model.RecipeItemId, ingredientId, quantity, true);
                    } else if ($ingredientIdFrom.length > 0) {
                        //if checked None option
                        ingredientIdFrom = parseInt($ingredientIdFrom.get(0).dataset.ingredientid || "") || -1;
                        result = Vendd.RecipeLibrary.RemoveIngredient(wrapper.model, wrapper.model.RecipeItemId, ingredientIdFrom, quantity, true);
                    }

                } else {
                    if ($ingredientIdFrom.length > 0 && !$(event.target).hasClass("active")) {
                        ingredientIdFrom = parseInt($ingredientIdFrom.get(0).dataset.ingredientid || "") || -1;
                        result = Vendd.RecipeLibrary.ChangeIngredient(wrapper.model, wrapper.model.RecipeItemId, ingredientIdFrom, ingredientId);
                    } else {
                        result = Vendd.RecipeLibrary.AddIngredient(wrapper.model, wrapper.model.RecipeItemId, ingredientId, quantity, true);
                    }
                }
            } else {
                result = Vendd.RecipeLibrary.AddIngredient(wrapper.model, wrapper.model.RecipeItemId, ingredientId, quantity, true);
            }
            if (!result) {
                //console.log("error");
            }
            if (!result.success) {
                //console.log(result.status);
                if (result.status.ErrorCode !== "0") {
                    wrapper.showErrorMessage($(event.target), result.status.ErrorCode);
                }
            } else {
                wrapper.model = result.data.recipe || wrapper.model;
                var ingredient = _.find(wrapper.model.Ingredients, function (i) { return i.IngredientId === ingredientId; }) || {};
                if ((ingredient.SubRecipeId || 0) > 0) {
                    var $subRecipeWrapper = $(".x-recipe-ingredients-wrapper[data-recipe-id='" + ingredient.SubRecipeId + "']", $wrapper);
                    var subRecipeWrapper = $subRecipeWrapper.get(0);
                    subRecipeWrapper.setCheckedItems();
                    subRecipeWrapper.setEnabledItems();
                }
            }
            setTimeout(function () {
                wrapper.setCheckedItems();
                wrapper.setEnabledItems();
                $(event.target).removeClass("loading");
                if (wrapper.config.SaveToDatabase) wrapper.checkChanges();
            }, 0);
        };

        var ifUnchecked = function (event) {
            if ($(event.target).hasClass("loading")) return;
            if ($(event.target).hasClass("disabled")) return;
            if ($(event.target).is(":radio")) return;
            $(event.target).addClass("loading");
            //var recipeId = id;
            var ingredientId = parseInt(event.target.dataset.ingredientid || "") || -1;
            var quantity = parseFloat(stringToNumber(event.target.dataset.quanta || "1") || 1);
            var result = Vendd.RecipeLibrary.RemoveIngredient(wrapper.model, wrapper.model.RecipeItemId, ingredientId, quantity, true);
            if (!result) {
                //console.log("error");
            }
            if (!result.success) {
                //console.log(result.status);
            } else {
                wrapper.model = result.data.recipe || wrapper.model;
            }
            setTimeout(function () {
                wrapper.setCheckedItems();
                wrapper.setEnabledItems();
                $(event.target).removeClass("loading");
                if (wrapper.config.SaveToDatabase) wrapper.checkChanges();
            }, 0);
        };

        wrapper.loading = function (loading) {
            if (loading) {
                $wrapper.addClass('x-loading');
            } else {
                $wrapper.removeClass('x-loading');
            }
        };

        wrapper.loading(true);

        wrapper.update = function () {
            wrapper.model.Literals = wrapper.literals;
            $.each(wrapper.model.Categories, function (index, category) {
                $.each(category.Groups, function (indexInGroupArray, group) {
                    $.each(group.Items, function (indexInItemArray, item) {
                        if (item.Description === item.Name) {
                            item.Description = null;
                        }
                    });
                });
            });
            wrapper.model.ParentImageURL = $('.js-image-container img', wrapper.$recipe_container).attr('src'); //Custom BJT
            var html = Vendd.Handlebars.parse(wrapper.config.PartialHtml, wrapper.model);
            wrapper.bind(html);

            if (!wrapper.config.isSubRecipe) {
                $('.x-recipe-ingredients-wrapper.issubrecipe', $wrapper).each(function (el, i) {
                    //console.log('SubRecipe');
                    recipeController($(this), configuratorOptions);
                });
            }
        };

        wrapper.bind = function bind(html) {
            $wrapper.html(html);

            wrapper.setCheckedItems();
            wrapper.setEnabledItems();
            if (wrapper.config.SaveToDatabase) wrapper.checkChanges();

            wrapper.bindEvents();

            $wrapper.show();

        };

        wrapper.bindEvents = function () {

            wrapper.initIcheck();
            wrapper.initIngredientsToggle();
            wrapper.initNextStep();
            wrapper.initTooltips();

            $.getElement(' input[data-ingredientid]:checkbox', $wrapper).off('change').on('change', checkboxChange);
            //$('input[data-ingredientid]', $wrapper).off('ifUnchecked').on('ifUnchecked', ifUnchecked);

            $.getElement(" .info-error-container .info-error-btn", $wrapper).off("click").on("click", function (e) {
                e.preventDefault();
                var $infoContainer = $(e.target).closest(".info-error-container");
                if ($infoContainer.hasClass("disabled")) return;
                var $errorHtml = $(".info-error-text", $infoContainer);
                $.fancybox.open($errorHtml, {
                    touch: {
                        vertical: false,
                        momentum: false
                    }
                });
            });
            if (!wrapper.config.isSubRecipe) {
                $.getElement(' .js-summary-show-button', $wrapper).off('click').on('click touchstart', function () {
                    //Custom BJT start
                    if (wrapper.config.IsPostalCodeMandatory) {
                        var storeLocator = (Vendd.StoreLocator || {}).Controller || {};
                        if (!storeLocator.Partner && storeLocator.CanChangeDealer) {
                            var callback = function () {
                                var storeLocator = (Vendd.StoreLocator || {}).Controller || {};
                                if (storeLocator.Partner) {
                                    setTimeout(function () {
                                        wrapper.Validate();
                                    }, 100);
                                }
                            };
                            openPostCodeSelector(callback);
                        } else {
                            wrapper.Validate();
                        }
                    } else {
                        wrapper.Validate();
                    }
                });

                $.getGlobalElement(' .js-edit-post-code', $wrapper).off('click').on('click touchstart', function () {
                    openPostCodeSelector(null);
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement(' .back-to-config-container', $wrapper).off('click').on('click touchstart', function () {
                    wrapper.showSummary(false);
                    scroll_to_class($wrapper, 90);
                });
            }

            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement('.js-submit-registration-button', $wrapper).off('click').on('click touchstart', function () {
                    var $this = $(this);
                    if ($this.hasClass("loading")) return;
                    wrapper.loading(true);
                    $this.addClass("loading");
                    var callback = {
                        success: function (response) {
                            wrapper.model.GlobalId = response.GlobalId;
                            wrapper.model.HashCode = response.HashCode;
                            wrapper.checkChanges();
                            var $successHtml = $.getGlobalElement('.success-registration-text', $wrapper);
                            $.fancybox.open($successHtml, {
                                touch: false,
                                btnTpl: {
                                    smallBtn:
                                        '<div class="containerButtonFancy"><button type="button" data-fancybox-close class="fancybox-button configurator-fancybox-close-small" title="{{CLOSE}}">' +
                                        'OK' +
                                        "</button> </div>"
                                },
                                afterClose: function () {
                                    parent.jQuery.fancybox.close();
                                }
                            });
                        }, error: function () {
                            var $errorHtml = $.getGlobalElement('.error-for-later-text', $wrapper);
                            $.fancybox.open($errorHtml, {
                                touch: {
                                    vertical: false,
                                    momentum: false,
                                    btnTpl: {
                                        smallBtn:
                                            '<div class="containerButtonFancy"><button type="button" data-fancybox-close class="fancybox-button configurator-fancybox-close-small" title="{{CLOSE}}">' +
                                            'OK' +
                                            "</button> </div>"
                                    },
                                    afterClose: function () {
                                        parent.jQuery.fancybox.close();
                                    }
                                }
                            });
                        }, finally: function () {
                            $this.removeClass("loading");
                            wrapper.loading(false);
                        }
                    };
                    var config = {
                        Force: true,
                        FriendlyName: "Register:" + wrapper.model.vin,
                        Vin: wrapper.model.vin,
                        PartnerId: wrapper.model.partnerId !== "" ? wrapper.model.partnerId : null
                    };
                    wrapper.saveData(callback, config);
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement('.save-for-later-container .button', $wrapper).off('click').on('click touchstart', function () {
                    var $this = $(this);
                    if ($this.hasClass("loading") || !wrapper.config.SaveToDatabase || $this.hasClass("disabled")) return;
                    $this.addClass("loading");
                    wrapper.loading(true);
                    var callback = {
                        success: function (response) {
                            wrapper.model.GlobalId = response.GlobalId;
                            wrapper.model.HashCode = response.HashCode;
                            wrapper.checkChanges();
                            var location;
                            if (wrapper.config.HasAuthorizedSave && !wrapper.model.isAuthenticated) {
                                var $unauthorized = $.getGlobalElement(".unauthorized-container", $wrapper);
                                var $link = $("a", $unauthorized);
                                location = UpdateQueryString("GlobalId", wrapper.model.GlobalId);
                                location = UpdateQueryString("DoSave", true, location);
                                $link.attr("href", LhApp.Url.Page.Login + "?returnUrl=" + encodeURIComponent(location));
                                $.fancybox.open($unauthorized, {
                                    touch: {
                                        vertical: false,
                                        momentum: false
                                    }
                                });
                            } else {
                                var $successHtml = $.getGlobalElement('.success-for-later-text', $wrapper);
                                location = UpdateQueryString("GlobalId", wrapper.model.GlobalId);
                                $("#saved-url", $successHtml).val(location);
                                $.fancybox.open($successHtml, {
                                    touch: false
                                });
                            }
                        }, error: function () {
                            var $errorHtml = $.getGlobalElement('.error-for-later-text', $wrapper);
                            $.fancybox.open($errorHtml, {
                                touch: {
                                    vertical: false,
                                    momentum: false
                                }
                            });
                        }, finally: function () {
                            $this.removeClass("loading");
                            wrapper.loading(false);
                        }
                    };
                    if (wrapper.config.isConfigurationPage) {
                        var config = {
                            Force: true,
                            FriendlyName: "Register:" + wrapper.model.vin,
                        }
                        wrapper.saveData(callback, config);
                    } else {
                        var $fancyprompt = $(".fancybox-prompt-container");
                        if ($fancyprompt.length > 0) {
                            fancyPrompt($fancyprompt, $(".product-name").text() || "", function (friendlyName) {
                                if (friendlyName !== null && friendlyName !== "") {
                                    var config = {
                                        Force: true,
                                        FriendlyName: friendlyName
                                    }
                                    wrapper.saveData(callback, config);
                                } else {
                                    $this.removeClass("loading");
                                    wrapper.loading(false);
                                }
                            });
                        }
                    }

                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement(' .download-pdf-container .button', $wrapper).off('click').on('click touchstart', function (e) {
                    e.preventDefault();
                    var $this = $(this);
                    if ($this.hasClass("loading") || !wrapper.config.PdfExport || $this.hasClass("disabled")) return;
                    $this.addClass("loading");
                    wrapper.loading(true);

                    var callback = {
                        success: function (response) {
                            wrapper.model.GlobalId = response.GlobalId;
                            wrapper.model.HashCode = response.HashCode;

                            generatePDF($this);
                        }, error: function () {
                            var $errorHtml = $.getGlobalElement('.error-download-text', $wrapper);
                            $.fancybox.open($errorHtml, {
                                touch: {
                                    vertical: false,
                                    momentum: false
                                }
                            });
                        }, finally: function () {
                            $this.removeClass("loading");
                            wrapper.loading(false);
                        }
                    };
                    var config = {
                        FriendlyName: "Share",
                        IsShare: true
                    };
                    wrapper.saveData(callback, config);
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement(' .share-buttons .button', $wrapper).off('click').on('click touchstart', function () {
                    //στο share οταν σωζουμε, θα πρεπει να μπαινει friendly name οεο;
                    var $this = $(this);
                    if ($this.hasClass("loading") || !wrapper.config.ShareConfiguration || $this.hasClass("disabled")) return;
                    $this.addClass("loading");
                    wrapper.loading(true);

                    var callback = {
                        success: function (response) {
                            wrapper.model.GlobalId = response.GlobalId;
                            wrapper.model.HashCode = response.HashCode;
                            wrapper.checkChanges();
                            var location = UpdateQueryString("GlobalId", wrapper.model.GlobalId);
                            addthis.update('share', 'url', location);
                            addthis.url = location;
                            addthis.toolbox(".addthis_inline_share_toolbox");
                            $('.addthis_inline_share_toolbox').removeClass('hidden');
                        }, error: function () {
                            var $errorHtml = $.getGlobalElement('.error-share-text', $wrapper);
                            $.fancybox.open($errorHtml, {
                                touch: {
                                    vertical: false,
                                    momentum: false
                                }
                            });
                        }, finally: function () {
                            $this.removeClass("loading");
                            wrapper.loading(false);
                        }
                    };
                    var config = {
                        FriendlyName: "Share",
                        IsShare: true
                    };
                    wrapper.saveData(callback, config);
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement('.start-over-container', $wrapper).off('click').on('click touchstart', function (event) {
                    if ($(event.target).hasClass("disabled")) return;
                    wrapper.loading(true);
                    scroll_to_class($wrapper, 90);
                    $(event.target).addClass("disabled");
                    Vendd.RecipeLibrary.ResetRecipe(wrapper.initModel, id);
                    Vendd.RecipeLibrary.ClearLocalStorage();
                    wrapper.model = $.extend(true, {}, wrapper.initModel);
                    $.getElement(" .globalid-container", $wrapper).text(wrapper.model.GlobalId);
                    $.getElement(" .hashcode-container", $wrapper).text(wrapper.model.HashCode);
                    $.getElement(' input[data-ingredientid]', $wrapper).addClass("loading");
                    wrapper.update();
                    $(event.target).removeClass("disabled");
                    $(".js-full-screen-popup").addClass("disabled");
                    wrapper.showSummary(false);
                    wrapper.loading(false);
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement('.fancybox-copy-to-clipboard', $wrapper).on("click touchstart", function () {
                    copyToClipboard();
                    $(this).addClass("copied").delay(1000).queue(function () {
                        $(this).removeClass("copied").dequeue();
                    });
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement('.one-dealer-container .button', $wrapper).off('click').on('click touchstart', function () {
                    var $this = $(this);
                    if ($this.hasClass("loading") || !wrapper.config.SendToOneDealer || $this.hasClass("disabled")) return;
                    wrapper.loading(true);
                    $this.addClass("loading");
                    var callback = {
                        success: function (response) {
                            wrapper.model.GlobalId = response.GlobalId;
                            wrapper.model.HashCode = response.HashCode;
                            wrapper.checkChanges();
                            var $successHtml = $.getGlobalElement('.success-registration-text', $wrapper);
                            $.fancybox.open($successHtml, {
                                touch: false,
                                btnTpl: {
                                    smallBtn:
                                        '<div class="containerButtonFancy"><button type="button" data-fancybox-close class="fancybox-button configurator-fancybox-close-small" title="{{CLOSE}}">' +
                                        'OK' +
                                        "</button> </div>"
                                },
                                afterClose: function () {
                                    parent.jQuery.fancybox.close();
                                }
                            });
                            if (window.parent) {
                                var oneDealerResponse = Vendd.RecipeLibrary.GetOneDealerData(wrapper.model.RecipeItemId);
                                if (oneDealerResponse.success) {
                                    window.parent.postMessage(oneDealerResponse.data, "*");
                                }
                            }
                        }, error: function () {
                            var $errorHtml = $.getGlobalElement('.error-for-later-text', $wrapper);
                            $.fancybox.open($errorHtml, {
                                touch: {
                                    vertical: false,
                                    momentum: false,
                                    btnTpl: {
                                        smallBtn:
                                            '<div class="containerButtonFancy"><button type="button" data-fancybox-close class="fancybox-button configurator-fancybox-close-small" title="{{CLOSE}}">' +
                                            'OK' +
                                            "</button> </div>"
                                    },
                                    afterClose: function () {
                                        parent.jQuery.fancybox.close();
                                    }
                                }
                            });
                        }, finally: function () {
                            $this.removeClass("loading");
                            wrapper.loading(false);
                        }
                    };
                    var config = {
                        Force: true,
                        FriendlyName: "OneDealer:" + wrapper.model.vin
                    };
                    wrapper.saveData(callback, config);
                });
            }
        };

        var openPostCodeSelector = function (callback) {
            $.fancybox.open($('.js-post-code-selector'), {
                touch: {
                    vertical: false,
                    momentum: false
                },
                //modal: true,
                afterClose: function (e, i) {
                    if (callback) callback();
                }
            });
        };

        var fancyPrompt = function ($element, initVal, callback) {
            var value;
            $.fancybox.open($element, {
                touch: {
                    vertical: false,
                    momentum: false
                },
                beforeShow: function () {
                    $('input', $element).val(initVal);
                },
                afterShow: function () {
                    $element.on('keyup', function (event) {
                        if (event.keyCode === 27) {
                            value = null;
                            $.fancybox.close();
                        }
                        if (event.keyCode === 13) {
                            $(".fancybox-prompt-ok").trigger("click");
                        }
                    });
                    $('input', $element).change(function () {
                        $('.error-wrapper', $element).addClass(".hidden");
                    });
                    $(".fancybox-prompt-button").on("click touchstart", function (event) {
                        if ($(event.target).is(".fancybox-prompt-ok")) {
                            value = $('input', $element).val();
                            if (value === "") {
                                $('.error-wrapper', $element).removeClass(".hidden");
                            }
                        } else {
                            value = null;
                        }
                        $.fancybox.close();
                    });
                    $('input', $element).focus();
                },
                afterClose: function () {
                    $element.off('keyup');
                    callback.call(this, value);
                }
            });
        };

        var getUserData = function () {
            //set user fullname to PDF
            var user = JSON.parse(localStorage.getItem("CurrentUserModel"));
            var fullname = user.FirstName + ' ' + user.LastName;
            $('.pdf-header-container .user-name', $('.js-pdf-header')).html(fullname);
            //if authenticated add hide class else no
            if (user.IsAuthenticated) {
                $(".pdf-header-subtitle").hide();
                $(".authenticatedSubtitle").show();
            }
            else {
                $(".pdf-header-subtitle").show();
                $(".authenticatedSubtitle").hide();
            }
            //Add current Date to PDF 
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            today = dd + '.' + mm + '.' + yyyy;
            $('.pdf-header-container .user-time', $('.js-pdf-header')).html(today);
        };
        var generatePDF = function ($el) {
            $button = $el;
            var coverPdf = null;
            if ($button.data('coverpdf') !== '') {
                coverPdf = 'https:' + $button.data('coverpdf');
            }
            getUserData();
            var location = UpdateQueryString("GlobalId", wrapper.model.GlobalId);
            $.when(getShortenedUrl(location)).done(function () {
                $(".qr-wrapper img").on("load", function () {
                    $(".qr-wrapper img").attr({
                        "width": 120,
                        "height": 120
                    });
                    //coverPdf = "https://bjt.staginglh.com/Uploads/130750/68ca_config_a2transporter_125-1010.pdf";
                    var requestData = {
                        "url": null,
                        "externalLink": coverPdf,
                        "externalLinkFirst": null,
                        "filename": "configurator",
                        "filenamehassuffixdatetime": true,
                        "pagesize": null,
                        "pageorientation": null,
                        "parameters": {
                            "hasprintcss": true
                        },
                        html: getHtmlBodyForPdf(),
                        headerhtml: getHtmlHeaderForPdf(),
                        footerhtml: getHtmlFooterForPdf(),
                        "HeaderHeight": 140,
                        "FooterHeight": 50,
                        "margin": {
                            "top": 0,
                            "bottom": 0,
                            "left": 25,
                            "right": 25
                        }
                    };
                    var successDownload = function (pdf) {
                        const blob = b64toBlob(pdf.FileContents, 'application/pdf');
                        const blobUrl = URL.createObjectURL(blob);
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, pdf.Filename);
                        } else {
                            var a = document.createElement("a");
                            a.style.visibility = 'hidden';
                            document.body.appendChild(a);
                            var fileURL = URL.createObjectURL(blob);
                            a.href = fileURL;
                            a.download = pdf.Filename;
                            a.click();
                            document.body.removeChild(a);
                            setTimeout(function () {
                                // For Firefox it is necessary to delay revoking the ObjectURL
                                //window.URL.revokeObjectURL(fileURL);
                            }, 500);
                        }
                    };
                    var errorDownload = function (response) {
                        var $errorHtml = $('.error-download-text', wrapper.$recipe_container);
                        $.fancybox.open($errorHtml, {
                            touch: {
                                vertical: false,
                                momentum: false
                            }
                        });
                    };
                    $.ajax({
                        type: "POST",
                        dataType: 'json',
                        contentType: 'application/json; charset=UTF-8',
                        url: "/services/api/PdfExporter/Generate",
                        async: false,
                        data: JSON.stringify(requestData),
                        success: successDownload,
                        error: errorDownload,
                        complete: function (response) {
                            $button.removeClass("loading");
                            wrapper.loading(false);
                        }
                    });
                });
            });
        };
        var getHtmlHeaderForPdf = function () {
            $("header img").each(function (i, img) {
                var $img = $(img);
                $img
                    .attr("data-width", $img.width())
                    .attr("data-height", $img.height());
            });
            var $bodyclone = $("html").clone();
            var $pdfHeader = $(".js-pdf-header").clone();
            $("img", $pdfHeader).each(function (i, img) {
                var $img = $(img);
                var src = $img.attr("src");
                if (src.startsWith("//")) $img.attr("src", "https:" + src);
            });
            return $pdfHeader.html();
        };

        var getHtmlFooterForPdf = function () {
            var $pdfFooter = $(".js-pdf-footer").clone();
            $("img", $pdfFooter).each(function (i, img) {
                var $img = $(img);
                var src = $img.attr("src");
                if (src.startsWith("//")) $img.attr("src", "https:" + src);
            });
            return $pdfFooter.html();
        };

        var getHtmlBodyForPdf = function () {

            $("img").each(function (i, img) {
                var $img = $(img);
                $img
                    .attr("data-width", $img.width())
                    .attr("data-height", $img.height());
            });
            var $bodyclone = $("html").clone();
            $("script", $bodyclone).remove();
            $(".js-pdf-header, .js-pdf-footer", $bodyclone).remove();
            var maxWidth = 400;
            var maxHeight = 200;
            $("img", $bodyclone).each(function (i, img) {
                if ($(this).attr("src") !== null) {
                    var $img = $(img);
                    var src = $img.attr("src");
                    if (src.startsWith("//")) $img.attr("src", "https:" + src);
                    //fix images width and height
                    var scaleWidth = maxWidth / $img.attr("data-width");
                    if (scaleWidth > 1) scaleWidth = 1;
                    var scaleHeight = maxHeight / $img.attr("data-height");
                    if (scaleHeight > 1) scaleHeight = 1;
                    var scale = scaleWidth < scaleHeight ? scaleWidth : scaleHeight;
                    var width = $img.attr("data-width") * scale;
                    var height = $img.attr("data-height") * scale;
                    $img
                        .width(width + "px")
                        .height(height + "px");
                }
            });
            if (wrapper.config.isConfigurationPage) {
                $(".configurator-container", $bodyclone).toggleClass("hidden", true);
                $(".summary-container", $bodyclone).toggleClass("hidden", false);
            }
            return $bodyclone
                .html()
                .replace(/(")/gm, "'")
                .replace(/(\\)/gm, "\\\\")
                .replace(/(\r\n|\n|\r)/gm, "");
        };

        var b64toBlob = function (b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        };

        wrapper.saveData = function (callback, config) {
            var save = function (callback, config) {
                var htmlData = {
                    Body: getHtmlBodyForPdf(),
                    Header: getHtmlHeaderForPdf(),
                    Footer: getHtmlFooterForPdf()
                };

                var defaultConfiguration = {
                    RecipeId: wrapper.model.RecipeItemId,
                    Force: false,
                    FriendlyName: "",
                    Vin: wrapper.model.vin,
                    PartnerId: wrapper.model.partnerId !== "" ? wrapper.model.partnerId : null,
                    HtmlData: htmlData,
                    callback: callback
                };
                config = $.extend({}, defaultConfiguration, config || {});

                $.when(Vendd.RecipeLibrary.GenerateGlobalId(config))
                    .done(
                        function (response) {
                            if (callback && callback.success) callback.success(response.data);
                            return;
                        })
                    .fail(
                        function (response) {
                            if (callback && callback.error) callback.error(response);
                            return;
                        })
                    .always(
                        function (response) {
                            if (callback && callback.finally) callback.finally(response);
                            return;
                        });
            };
            if (wrapper.config.IsPostalCodeMandatory) {
                var storeLocator = (Vendd.StoreLocator || {}).Controller || {};
                if (!storeLocator.Partner) {
                    openPostCodeSelector(function () {
                        var storeLocator = (Vendd.StoreLocator || {}).Controller || {};
                        if (storeLocator.Partner) {
                            save(callback, config);
                        } else {
                            $.fancybox.close(true);
                        }
                    });
                    return;
                }
            }
            save(callback, config);
        };

        wrapper.loadData = function (callback, config) {

            var defaultConfiguration = {
                RecipeId: wrapper.model.RecipeItemId
            };
            var _config = $.extend({}, defaultConfiguration, config || {});

            var storeLocator = (Vendd.StoreLocator || {}).Controller || {};
            var callbacks = {
                onSuccess: function (response) {
                    if (response.success) {
                        //var ShippingCostText = numberToString2(response.data, true);
                        wrapper.model.ShippingCost = parseFloat(response.data);
                        //wrapper.model.ShippingCostText = ShippingCostText;
                        //$.getElement(' .summary-shipping-price', $wrapper).html(ShippingCostText);
                        //$.getGlobalElement(' .delivery-value', $wrapper).html(ShippingCostText);
                        wrapper.calculatePrice();
                        wrapper.calculateWeight();
                        //$.fancybox.close(true);
                    }
                }
            };
            if (storeLocator.Partner && !wrapper.config.isSubRecipe) {
                storeLocator.SetCallbacks(callbacks);
                storeLocator.GetShippingCost();
            } else if (Vendd.StoreLocator && !wrapper.config.isSubRecipe) {
                Vendd.MessageBus.subscribe(Vendd.StoreLocator.Messages.Initialized, wrapper, function () {
                    storeLocator.SetCallbacks(callbacks);
                    storeLocator.GetShippingCost();
                });
            }
            var response;
            if (wrapper.config.isSubRecipe) {
                response = Vendd.RecipeLibrary.GetModel(wrapper.model.RecipeItemId);
                if (callback && callback.success && response.success) callback.success(response);
                if (callback && callback.error && !response.success) callback.error(response);
                if (callback && callback.finally) callback.finally(response);
            }
            else if (_config.GlobalId !== "" && wrapper.config.LoadFromDatabase) {
                $.when(Vendd.RecipeLibrary.LoadFromGlobalId(_config))
                    .done(
                        function (response) {
                            if (storeLocator.Partner) {
                                storeLocator.FindPartner();
                            } else if (Vendd.StoreLocator) {
                                Vendd.MessageBus.subscribe(Vendd.StoreLocator.Messages.Initialized, wrapper, function () {
                                    storeLocator.FindPartner();
                                });
                            }
                            if (callback && callback.success) callback.success(response);
                            return;
                        })
                    .fail(
                        function (response) {
                            if (callback && callback.error) callback.error(response);
                            return;
                        })
                    .always(
                        function (response) {
                            if (callback && callback.finally) callback.finally(response);
                            wrapper.loading(false);
                            return;
                        });
            } else if (wrapper.config.OnLoadPageLoadFromLocalStorage) {
                wrapper.config.LoadFromDatabase = false;
                response = Vendd.RecipeLibrary.LoadFromLocalRecipeItems(wrapper.model.RecipeItemId);
                if (response.success) {
                    wrapper.model.RecipeItems = response.data.Recipe.RecipeItems;
                    if (callback && callback.success) callback.success(response);
                } else {
                    wrapper.update();
                }
                if (callback && callback.finally) callback.finally(response);
                wrapper.loading(false);
            } else {
                wrapper.config.LoadFromDatabase = false;
                wrapper.update();
                wrapper.loading(false);
            }
        };

        wrapper.assignConfigurationToUser = function (callback, config) {
            var defaultConfiguration = {
                RecipeItemId: wrapper.config.RecipeItemId,
                callback: callback
            };
            config = $.extend({}, defaultConfiguration, config || {});

            $.when(Vendd.RecipeLibrary.AssignConfigurationToUser(config))
                .done(
                    function (response) {
                        if (callback && callback.success) callback.success(response.data);
                        return;
                    })
                .fail(
                    function (response) {
                        if (callback && callback.error) callback.error(response);
                        return;
                    })
                .always(
                    function (response) {
                        if (callback && callback.finally) callback.finally(response);
                        return;
                    });
        };

        wrapper.hideAllErrors = function () {
            $.getGlobalElement(".recipe-error-container", $wrapper).addClass("hidden");
            $.getElement(".category-items .group-error-container", $wrapper).addClass("hidden");
            $.getElement(".category-items .info-error-container", $wrapper).addClass("disabled");
            $.getElement(".ingredient", $wrapper).removeClass("disabled");
        };

        wrapper.showErrorMessage = function ($item, code, incompatibles, missingPrerequisites, missingAnyOfPrerequisites) {
            var $ingredient = $item.closest(".category-item");
            var $infoContainer = $(".info-error-container", $ingredient);
            if ($infoContainer.length === 0) return;
            var errorHtml = $.getGlobalElement(".error[data-code='" + code + "']", $wrapper).html();
            var template = "<li><a class='scroll-to-ingredient goto-item' data-goto-ingredient-id='{0}'>{2} {1}</a></li>";
            if (code === 1030) {
                errorHtml = errorHtml.replace("{0}", "<ul>" + _.map((incompatibles || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode); }).join("") + "</ul>");
            }
            if (code === 1031) {
                errorHtml = errorHtml.replace("{0}", "<ul>" + _.map((missingPrerequisites || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode).replace("{0}", item.Name); }).join("") + "</ul>");
            }
            if (code === 1032) {
                errorHtml = errorHtml.replace("{0}", "<ul>" + _.map((incompatibles || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode); }).join("") + "</ul>");
                errorHtml = errorHtml.replace("{0}", "<ul>" + _.map((missingPrerequisites || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode).replace("{0}", item.Name); }).join("") + "</ul>");
            }
            if (code === 1033) {
                var missingAnyOfPrerequisitesHtml = "";
                for (var i = 0; i < missingAnyOfPrerequisites.length; i++) {
                    var items = missingAnyOfPrerequisites[i];
                    missingAnyOfPrerequisitesHtml += "<ul>" + _.map((items || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode).replace("{0}", item.Name); }).join("") + "</ul>";
                }
                errorHtml = errorHtml.replace("{0}", missingAnyOfPrerequisitesHtml);
            }
            $(".info-error-text", $infoContainer).html(errorHtml);
            $infoContainer.removeClass("disabled");

            $(".inner-wrapper", $infoContainer).html(errorHtml);
            initScrollToIngredient($(".inner-wrapper .scroll-to-ingredient", $infoContainer));
            $infoContainer.removeClass("hidden");
        };

        wrapper.showGeneralErrorMessage = function (errorItem) {
            var $templateErrors = $.getElement(" .summary-error-generate-template", $wrapper);
            var errorCode = (errorItem.ErrorCodes || []).length > 0 ? errorItem.ErrorCodes[0] : errorItem.ErrorCode;
            var errorHtml = $.getGlobalElement(".error[data-code='" + errorCode + "']", $wrapper).html();
            var relatedItemsHtml = "";
            var $templateClone = $templateErrors.clone().removeClass("summary-error-generate-template").addClass("generated");

            if (errorItem.Id || 0 > 0) {
                var $group = $.getElement(" .category-items[data-groupId='" + (errorItem.Id || 0) + "']", $wrapper);
                if ($group) {
                    var groupIndex = $group.index() + 1;
                    errorHtml = errorHtml.replace("{0}", errorItem.ExtraQuantity).replace("{1}", errorItem.Name).replace("{2}", errorItem.CategoryName).replace("{3}", groupIndex);
                    $(".group-error-container", $group).html(errorHtml).removeClass("hidden");
                    $templateClone.attr("data-goto-group-id", (errorItem.Id || 0)).addClass("goto-item");
                    $(".summary-item-name", $templateClone).addClass("hidden");
                }
            } else if (errorItem.IngredientId || 0 > 0) {
                var $ingredient = $.getElement(" .category-item[data-ingredientid='" + (errorItem.IngredientId || 0) + "']", $wrapper);
                if ($ingredient) {
                    var template = "<li><a class='goto-item' data-goto-ingredient-id='{0}'>{2} {1}</a></li>";
                    if (errorCode === 1030) {
                        relatedItemsHtml = "<ul>" + _.map((errorItem.Incompatibles || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode); }).join("") + "</ul>";
                    }
                    if (errorCode === 1031) {
                        relatedItemsHtml = "<ul>" + _.map((errorItem.MissingPrerequisites || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode); }).join("") + "</ul>";
                    }
                    if (errorCode === 1032) {
                        relatedItemsHtml = "<ul>" + _.map((errorItem.Incompatibles || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode); }).join("") + "</ul>"
                            + "<ul>" + _.map((errorItem.MissingPrerequisites || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode); }).join("") + "</ul>";
                    }
                    $(".summary-related-items", $templateClone).html(relatedItemsHtml);
                    errorHtml = errorHtml.replace("{0}", "");
                }
            } else {
                errorHtml = errorHtml.replace("{0}", errorItem.ExtraQuantity).replace("{1}", errorItem.Name);
                $.getGlobalElement(".recipe-error-container", $wrapper).html(errorHtml).removeClass("hidden");
            }

            if ((errorItem.IngredientId || 0 > 0)) {
                $(".summary-item-name", $templateClone).text(errorItem.Name)
                    .addClass("scroll-to-ingredient")
                    .attr("data-goto-ingredient-id", (errorItem.IngredientId || 0))
                    .addClass("goto-item");
            }
            $(".summary-error", $templateClone).html(errorHtml);
            var $parent = $.getElement(" .summary-category-general-errors .category-items", $wrapper);
            $templateClone.appendTo($parent);
            $(".goto-item", $templateClone).each(function () {
                initScrollToIngredient($(this));
            });
            if ($templateClone.hasClass("goto-item")) initScrollToIngredient($templateClone);
        };

        wrapper.checkChanges = function () {
            var localStorageHashCode = Vendd.RecipeLibrary.GetLocalStorageRecipeItemsHashCode(wrapper.model.RecipeItemId);
            var hasChanges = wrapper.model.HashCode !== localStorageHashCode;
            $(".globalid-container").text(wrapper.model.GlobalId).toggleClass("unsaved", hasChanges);
            $(".hashcode-container").text(wrapper.model.HashCode).toggleClass("unsaved", hasChanges);
            if (wrapper.config.SaveToLocalStorage) (Vendd.RecipeLibrary.SaveRecipeItemsToLocal(wrapper.model.RecipeItemId, wrapper.model.GlobalId)).success;
        };

        wrapper.setCheckedItems = function () {
            var result;
            if (wrapper.config.isSubRecipe) {
                result = (Vendd.RecipeLibrary.GetCheckedRecipeItems(wrapper.config.ParentRecipeItemId));
            }
            else {
                result = (Vendd.RecipeLibrary.GetCheckedRecipeItems(wrapper.model.RecipeItemId));
            }
            if (!result.success) {
                //console.log(result.status);
            } else {
                $.getGlobalElement(" .summary-category-standard-equipment .category-item.generated", $wrapper).remove();
                $.getGlobalElement(" .summary-category-optional-equipment .category-item.generated", $wrapper).remove();
                $.getGlobalElement(" .summary-category-general-errors .category-item.generated", $wrapper).remove();
                $.getGlobalElement(" .summary-category-outdated-equipment .category-item.generated", $wrapper).remove();
                var $template = $.getGlobalElement(".summary-item-generate-template", $wrapper);
                $.getElement(" input[data-ingredientid]", $wrapper)
                    .addClass('loading')
                    .off('change')
                    .prop("checked", false).removeClass("active");
                $('.x-recipe-ingredients-wrapper.issubrecipe', $wrapper).addClass("hidden");
                _.each(result.data.CheckedRecipeItems, function (item) {
                    if (wrapper.config.isSubRecipe && item.ProductItemId === wrapper.model.RecipeItemId) {
                        //change package price
                    }
                    if (item.IngredientId !== 0) {
                        //update summary
                        var $templateClone = $template.clone().removeClass("summary-item-generate-template").addClass("generated");
                        $templateClone.attr("data-ingredientid", item.IngredientId);
                        var IsStandard = '';
                        if (item.IsStandard) {
                            IsStandard = 'pdf-standard';
                        }
                        $(".summary-item-name", $templateClone).text(item.Name);
                        $(".summary-item-category", $templateClone).text(item.Category);
                        $(".summary-item-image img", $templateClone).attr("src", item.ImageUrl).parent().addClass(IsStandard);
                        var price = item.TotalPrice > 0 ? numberToString2(item.TotalPrice, true) : "";
                        $(".summary-item-price", $templateClone).text(price).addClass(IsStandard);
                        var $parent = item.IsStandard ?
                            $(".category.summary-category-standard-equipment .category-items") :
                            $(".category.summary-category-optional-equipment .category-items");
                        $templateClone.prependTo($parent);
                    }

                    if (item.RecipeItemId !== wrapper.model.RecipeItemId) return;
                    //set valid recipe items as checked
                    var $element = $.getElement(" [data-groupid='" + item.GroupId + "'] input[data-ingredientid='" + item.IngredientId + "']", $wrapper);
                    $element
                        .prop("checked", true)
                        .addClass("active");
                    var $ingredient = $element.closest(".ingredient");
                    $('.x-recipe-ingredients-wrapper', $ingredient).removeClass("hidden");
                });

                $.getElement(" .category.summary-category-standard-equipment", $wrapper).toggleClass("hidden", result.data.CheckedItemsStandardTotal === 0);
                $.getElement(" .category.summary-category-optional-equipment", $wrapper).toggleClass("hidden", result.data.CheckedItemsOptionalTotal === 0);

                $.getElement(" input[data-ingredientid]", $wrapper)
                    .removeClass('loading')
                    .on('change', checkboxChange);
                if (wrapper.model.ParentRecipeItemId === 0) {
                    wrapper.calculatePrice();
                    wrapper.calculateWeight();
                } else {
                    var parentWrapper = $wrapper.parents('.x-recipe-ingredients-wrapper').get(0);
                    if (parentWrapper) {
                        parentWrapper.calculatePrice();
                        parentWrapper.calculateWeight();
                    }
                }
            }
        };
        wrapper.checkIfLoggedIn = function () {
            var user = JSON.parse(localStorage.getItem('CurrentUserModel'));
            if (user !== null && user.FirstName && user.LastName) {
                $('.pdf-header-subtitle').hide();
                $('.pdf-header-logedin-subtitle').append('<span>' + user.FirstName + ' ' + user.LastName + '</span>').show();
            } else {
                $('.pdf-header-logedin-subtitle').hide();
                $('.pdf-header-subtitle').show();
            }
        };

        //wrapper.checkIfLoggedIn();
        wrapper.setEnabledItems = function () {
            wrapper.hideAllErrors();
            var result = Vendd.RecipeLibrary.GetEnabledItems(wrapper.model.RecipeItemId);
            if (!result.success) {
                //console.log(result.status);
                $.getElement(" input[data-ingredientid]", $wrapper).removeClass("loading");
            } else {
                $.getElement(" input[data-ingredientid]", $wrapper)
                    .addClass('disabled').prop("disabled", true);
                _.each(result.data.EnabledItems, function (item) {
                    var $item = $.getElement(" [data-groupid='" + item.GroupId + "'] input[data-ingredientid='" + item.IngredientId + "']", $wrapper);
                    var $ingredient = $item.closest(".ingredient");
                    if (item.ErrorCode > 0) {
                        wrapper.showErrorMessage($item, item.ErrorCode, item.Incompatibles, item.MissingPrerequisites, item.MissingAnyOfPrerequisites);
                    } else {
                        $(".error", $ingredient).addClass("hidden");
                    }
                    $item
                        .removeClass('disabled')
                        .prop("disabled", false);
                });
                _.each(result.data.DisableItems, function (item) {
                    var $item = $.getElement(" input[data-ingredientid='" + item.IngredientId + "']", $wrapper);
                    var $ingredient = $item.closest(".ingredient");
                    if ($ingredient.length > 0) {
                        wrapper.showErrorMessage($item, item.ErrorCode, item.Incompatibles, item.MissingPrerequisites, item.MissingAnyOfPrerequisites);
                        $ingredient.addClass("disabled");
                    }
                });

                _.each(result.data.Errors, function (error) {
                    wrapper.showGeneralErrorMessage(error);
                });

                _.each(result.data.GroupErrors, function (group) {
                    wrapper.showGeneralErrorMessage(group);

                });
            }
        };

        wrapper.calculatePrice = function () {
            var prices = Vendd.RecipeLibrary.GetPrices(wrapper.model.RecipeItemId) || {};
            prices.InitialPrice = prices.InitialPrice || 0;
            prices.StandardTotalPrice = prices.StandardTotalPrice || 0;
            prices.OptionalTotalPrice = prices.OptionalTotalPrice || 0;
            var shippingPrice = wrapper.model.ShippingCost || 0;
            var shippingPriceText = shippingPrice > 0 ? numberToString2(shippingPrice, true) : "";
            var optionalTotalPriceText = prices.OptionalTotalPrice > 0 ? numberToString2(prices.OptionalTotalPrice, true) : "";
            var totalPrice = prices.InitialPrice + prices.OptionalTotalPrice + prices.StandardTotalPrice + shippingPrice;
            var totalPriceText = totalPrice > 0 ? numberToString2(totalPrice, true) : "";
            var basicPrice = prices.InitialPrice + prices.StandardTotalPrice;
            var basicPriceText = basicPrice > 0 ? numberToString2(basicPrice, true) : "";
            $('.price-optional-value').html(optionalTotalPriceText);
            $('.total-price').html(totalPriceText);
            $('.basic-price').html(basicPriceText);
            $('.summary-shipping-price').html(shippingPriceText);
            $('.delivery-value').html(shippingPriceText);
        };
        wrapper.calculateWeight = function () {
            var weightObj = Vendd.RecipeLibrary.GetWeight(wrapper.model.RecipeItemId) || {};
            var remainingWeight = weightObj.InitialWeight - weightObj.OptionalTotalWeight;
            $('.load-capacity .value').html(remainingWeight);
            $('.load-capacity .product-details-value').toggleClass("error", remainingWeight < 0);
        };

        wrapper.initiallizeProductRecipe = function () {
            maxQuantity = parseInt(wrapper.model.MaxQuantity);
            maxFreeQuantity = parseInt(wrapper.model.MaxFreeQuantity);
            maxReplaceQuantity = parseInt(wrapper.model.MaxReplaceQuantity);
            $('.x-recipe .description').html(wrapper.model.MaxQuantityText);
            $('.x-recipe .selected-version-label').show();
            $('.x-recipe .selected-version').html($('.x-recipe .selected-version-label')[0]);
            recipeInitialPrice = parseFloat(stringToNumber($('.x-product-details .current-price').attr('data-price')));
            $('.page_ProductList[data-step-number]').each(function (index, value) {
                var step = $(this).data("step-number");
                if ($('.price-container[data-combo-recipe' + step + ']').length === 0) return;
                var price = parseFloat(stringToNumber($('.price-container').attr("data-combo-recipe" + step)));
                recipeInitialPrice = recipeInitialPrice + price;
            });
            $('.x-product-details .current-price').html(recipeInitialPrice.toFixed(2).replace('.', ',') + '€');
            recipePrice = recipeInitialPrice;
            comboRecipePrice = 0;
            defaultQuantity = 0;
            currentQuantity = 0;
            $wrapper.get(0).recipeItems = [];
        };

        wrapper.initTooltips = function () {
            var $wrapperTooltips = $.getElement(' .tooltip-info-wrapper', $wrapper);

            if ($wrapperTooltips.length < 1)
                return;

            $wrapperTooltips.each(function (i, el) {
                intiTooltip($(el));
            });

            $(document).on('click touchstart', function (e) {
                var $wrapperTooltips = $.getElement(' .tooltip-info-wrapper', $wrapper);
                var $selectedWrapper = $wrapperTooltips.is(e.target) ? $(e.target) : $(e.target).closest($wrapperTooltips).first();
                var $toolbox = $('.info-tooltip', $selectedWrapper);
                $('.info-tooltip', $wrapperTooltips).not($toolbox).attr('style', '');
            });
        };

        var intiTooltip = function ($tooltip) {
            $tooltip.on("click touchstart", function (e) {
                if ($(this).is('.category-item') && !$(this).hasClass("disabled") && $(e.target).is("input")) return;
                if ($(this).hasClass("category-title") && $(this).parent('.category').length > 0 && !$(this).parent('.category').hasClass("disabled")) return;
                if ($(this).hasClass('category-item') && $(this).find(".info-error-container").hasClass("disabled")) return;
                if ($(e.target).hasClass("more-info-btn")) return;
                var $tooltipBox = $(this).find('.info-tooltip');
                $('.info-tooltip', $tooltip).not($tooltipBox).attr('style', '');
                $tooltipBox.toggle();
            });
        };

        var initScrollToIngredient = function ($item) {
            $item.off("click").on("click touchstart", function () {
                var groupId = parseInt($(this).attr("data-goto-group-id") || "0");
                var ingredientId = parseInt($(this).attr("data-goto-ingredient-id") || "0");
                goToItem(groupId, ingredientId);
            });
        };

        var goToItem = function (groupId, ingredientId) {
            var $item = groupId > 0 ?
                $.getElement(" .configurator-container .ingredients[data-groupid='" + groupId + "']", $wrapper) :
                $.getElement(" .configurator-container .ingredient[data-ingredientid='" + ingredientId + "']", $wrapper);
            if ($item.length === 0) return;
            var $congifuratorPage = $.getElement(" .configurator-container", $wrapper);
            if (!$congifuratorPage.is(":visible")) {
                wrapper.showSummary(false);
            }
            //$(".configurator-container .category", $wrapper).toggleClass("opened", false);
            var $category = $item.closest(".category");
            $category.toggleClass("opened", true);
            scroll_to_class($item, 90);
        };

        wrapper.initIcheck = function () {
            var $input = $.getGlobalElement('input', $wrapper);
        };

        wrapper.initIngredientsToggle = function () {
            $.getElement(' .category-title', $wrapper).click(function () {
                var $this = $(this);
                var $category = $this.closest('li.category');
                if ($category.hasClass("disabled")) return;
                $category.toggleClass("opened");
                if ($category.hasClass("wizard")) {
                    if ($category.is(":last-child")) {
                        $.getElement(" .button-show-summary-wrapper", $wrapper).removeClass("hidden");
                        $.getElement(" .button-submit-registration", $wrapper).removeClass("hidden");
                    }

                    var $nextCategory = $category.next();
                    if ($nextCategory.length > 0) {
                        $nextCategory.removeClass("disabled");
                    }
                }
            });
        };

        wrapper.initNextStep = function () {
            $.getElement(' li.category.wizard:not(:first-child):not(:nth-child(2))', $wrapper).addClass("disabled");
            if ($.getElement(' li.category.wizard', $wrapper).length === 1) {
                $.getElement(" .button-show-summary-wrapper", $wrapper).removeClass("hidden");
                $.getElement(" .button-submit-registration", $wrapper).removeClass("hidden");
            }

            $.getElement(' .next-step-center', $wrapper).on("click", function () {
                var $this = $(this);
                var $category = $this.closest('li.category');
                var $categoryTitle = $category.find('.category-title');

                if ($category.hasClass("disabled")) return;

                $category.removeClass("opened");

                var $nextCategory = $category.next();
                if ($nextCategory.length > 0) {
                    $nextCategory.addClass("opened").slideToggle(0);
                    $nextCategory.slideToggle(600);
                    scroll_to_class($nextCategory, 90);
                    if ($nextCategory.is(":last-child")) {
                        $.getElement(" .button-show-summary-wrapper", $wrapper).removeClass("hidden");
                        $.getElement(" .button-submit-registration", $wrapper).removeClass("hidden");
                    }
                    if ($nextCategory.next().length > 0) $nextCategory.next().removeClass("disabled");
                }
            });
        };

        var loadDataError = function (response, errorCode) {
            var $errorHtml = $.getGlobalElement(".error[data-code='" + (errorCode || response.status.ErrorCode || "1070") + "']", $wrapper);
            $.fancybox.open($errorHtml, {
                touch: {
                    vertical: false,
                    momentum: false
                }
            });
            wrapper.model.IsAuthorized = (errorCode === "1061" && wrapper.config.isConfigurationPage) || wrapper.model.IsAuthenticated;

            wrapper.showSummary(false);
        };

        var loadDataSuccess = function (response) {
            if ((!response.success || !response.data || !(response.data.GlobalId && wrapper.config.LoadFromDatabase)) && !wrapper.config.isSubRecipe) {
                var errorCode = (response.data && !response.data.GlobalId ? "1071" : "1070");
                loadDataError(response, errorCode);
                return;
            }
            wrapper.model.GlobalId = response.data.GlobalId;
            wrapper.model.HashCode = response.data.HashCode;
            wrapper.model.CanEdit = response.data.CanEdit;
            $.getElement(" .globalid-container", $wrapper).text(wrapper.model.GlobalId);
            $.getElement(" .hashcode-container", $wrapper).text(wrapper.model.HashCode);

            var result;
            if (wrapper.config.isSubRecipe) {
                wrapper.model.RecipeItems = response.data.RecipeItems;
                result = Vendd.RecipeLibrary.SetRecipeItems(wrapper.model.RecipeItemId, wrapper.model.RecipeItems);
                if (!result.success) {
                    //console.log(result.status);
                    loadDataError(response, "1071");
                    return;
                }
                wrapper.update();
                wrapper.setCheckedItems();
                wrapper.setEnabledItems();
                wrapper.loading(false);
                return;
            } else if (wrapper.model.GlobalId) {
                wrapper.model.RecipeItems = response.data.RecipeItems;
                result = Vendd.RecipeLibrary.SetRecipeItems(wrapper.model.RecipeItemId, wrapper.model.RecipeItems);
                result.SavedGlobalIdToLocal = (Vendd.RecipeLibrary.SaveGlobalIdToLocal(wrapper.model.RecipeItemId, wrapper.model.GlobalId)).success;
                if (wrapper.config.SaveToLocalStorage && wrapper.model.GlobalId) result.SaveRecipeItemsToLocal = (Vendd.RecipeLibrary.SaveRecipeItemsToLocal(wrapper.model.RecipeItemId, wrapper.model.GlobalId)).success;
                if (!result.success) {
                    //console.log(result.status);
                    loadDataError(response, "1071");
                    return;
                }
            }

            wrapper.update();

            if (response.data.IsValid) {
                var storeLocator = (Vendd.StoreLocator || {}).Controller || {};
                if (!storeLocator.Partner && $.getGlobalElement('.js-post-code-selector', $wrapper).length > 0) {
                    openPostCodeSelector(null);
                }
                wrapper.setCheckedItems();
                wrapper.setEnabledItems();
            } else {
                onValidateError(response);
            }
            wrapper.showSummary(true);
        };

        wrapper.Validate = function () {
            var response = {};
            var data = Vendd.RecipeLibrary.IsValid(wrapper.model.RecipeItemId);
            response.data = data || {};
            _.each(_.filter(wrapper.model.RecipeItems, function (item) { return item.SubRecipeId > 0; }),
                function (recipe) {
                    var subrecipe_data = Vendd.RecipeLibrary.IsValid(recipe.ProductItemId) || {};
                    if (response.data.IsValid && !subrecipe_data.IsValid) {
                        ($(".issubrecipe[data-id='" + recipe.ProductItemId + "']").get(0)).Validate();
                    }
                    response.data.IsValid = response.data.IsValid && subrecipe_data.IsValid;
                });

            if (response.data.IsValid) {
                onValidateSuccess(response);
                wrapper.showSummary(true);
                scroll_to_class($wrapper, 90);
            } else {
                onValidateError(response);
                var $firstError = $.getElement(" .group-error-container:not(.hidden),.x-recipe-ingredients:not(.x-subrecipe) .recipe-error-container:not(.hidden)", $wrapper).first();
                if (response.data.GroupErrors.length > 0 && $firstError.length) {
                    var $categoryError = $firstError.closest(".category");
                    $categoryError.toggleClass("opened", true);
                    scroll_to_class($firstError, 90);
                } else if (response.data.IngredientsErrors.length > 0) {
                    $.each(response.data.IngredientsErrors, function (i, error) {
                        $el = $.getElement(" .ingredients .info-error-container:not(.disabled)", $wrapper).closest(".ingredient[data-ingredientid='" + error.IngredientId + "']");
                        $input = $("input", $el);
                        if ($input.is(':checked')) {
                            var $categoryError = $el.closest(".category");
                            $categoryError.toggleClass("opened", true);
                            scroll_to_class($el, 90);
                            return false;
                        }
                    });
                }
            }
        };

        var onValidateError = function (response) {

            $.getElement(" .back-to-config-container", $wrapper).toggleClass("hidden", true);
            $.getGlobalElement(".save-for-later-container .button", $wrapper).addClass("disabled").prop("disabled", true);
            if ((wrapper.model.GlobalId || 0) === 0) $.getGlobalElement(".download-pdf-container .button", $wrapper).addClass("disabled").prop("disabled", true);
            if ((wrapper.model.GlobalId || 0) === 0) $.getGlobalElement(".share-buttons .button", $wrapper).addClass("disabled").prop("disabled", true);
            if ((wrapper.model.GlobalId || 0) === 0) $.getGlobalElement(".one-dealer-container .button", $wrapper).addClass("disabled").prop("disabled", true);
            $.getElement(" .summary-category-error", $wrapper).toggleClass("hidden", response.data.Errors.length === 0 && response.data.GroupErrors.length === 0 && response.data.IngredientsErrors.length === 0);
            $.getElement(' .summary-category-error .category-description a', $wrapper).off("click touchstart").on("click touchstart", function () {
                wrapper.showSummary(false);
                scroll_to_class($wrapper, 90);
            });
            $.getElement(" .summary-category-error .category-item.generated", $wrapper).remove();
            $.getGlobalElement(".validate-info-container .alert", $wrapper).removeClass("hidden");
            $.getGlobalElement(".validate-info-container .warning", $wrapper).toggleClass("hidden", !((response.data.IngredientsWarnings || []).length > 0));

            var ingredientsOutdatedErrors = _.filter(response.data.IngredientsErrors, function (i) { return i.ErrorCodes.includes(1072); });
            var ingredientsGeneralErrors = _.filter(response.data.IngredientsErrors, function (i) { return !i.ErrorCodes.includes(1072); });

            $.getElement(" .summary-category-outdated-equipment", $wrapper).toggleClass("hidden", ingredientsOutdatedErrors.length === 0);
            var $templateOutdated = $.getElement(" .summary-outdated-item-generate-template", $wrapper);
            _.each(ingredientsOutdatedErrors, function (item) {
                var $templateClone = $templateOutdated.clone().removeClass("summary-outdated-item-generate-template").addClass("generated");
                $templateClone.attr("data-ingredientid", item.IngredientId);
                $(".summary-item-name", $templateClone).text(item.Name);
                var price = item.Price > 0 ? numberToString2(item.Price, true) : "";
                $(".summary-item-price", $templateClone).text(price);
                var $parent = $.getElement(" .summary-category-outdated-equipment .category-items", $wrapper);
                $templateClone.appendTo($parent);
            });

            _.each(ingredientsGeneralErrors, function (item) {
                wrapper.showGeneralErrorMessage(item);
            });

            $.getElement(" .summary-category-general-errors", $wrapper).toggleClass("hidden", response.data.Errors.length === 0 && response.data.GroupErrors.length === 0 && ingredientsGeneralErrors.length === 0);
            _.each(response.data.Errors, function (item) {
                wrapper.showGeneralErrorMessage(item);
            });

            _.each(response.data.GroupErrors, function (group) {
                wrapper.showGeneralErrorMessage(group);
            });

            _.each(response.data.IngredientsWarnings, function (item) {
                var $item = $.getElement(" .summary-container .category-item[data-ingredientid='" + item.IngredientId + "']", $wrapper);
                if ($item.length > 0) {
                    wrapper.showErrorMessage($item, item.ErrorCodes[0], null, null, null);//<--- fix to multiple errors
                    $item.addClass("tooltip-info-wrapper");
                    intiTooltip($item);
                };
            });
        };

        var onValidateSuccess = function (response) {

            $.getElement(" .back-to-config-container", $wrapper).toggleClass("hidden", false);
            $.getElement(" .summary-category-error", $wrapper).addClass("hidden");
            $.getElement(" .summary-category-general-errors", $wrapper).addClass("hidden");
            $.getElement(" .summary-category-outdated-equipment", $wrapper).addClass("hidden");
            $.getElement(" .summary-category-general-errors .category-item.generated", $wrapper).remove();
            $.getElement(" .summary-category-outdated-equipment .category-item.generated", $wrapper).remove();
            $.getElement(" .summary-container .info-error-container", $wrapper).addClass("disabled");
            $.getGlobalElement(".save-for-later-container .button", $wrapper).removeClass("disabled");
            $.getGlobalElement(".download-pdf-container .button", $wrapper).removeClass("disabled");
            $.getGlobalElement(".share-buttons .button", $wrapper).removeClass("disabled");
            $.getGlobalElement(".one-dealer-container .button", $wrapper).removeClass("disabled");
            $.getGlobalElement(".validate-info-container .alert", $wrapper).addClass("hidden");
            $.getGlobalElement(".validate-info-container .warning", $wrapper).toggleClass("hidden", !((response.data.IngredientsWarnings || []).length > 0));


            _.each(response.data.IngredientsWarnings, function (item) {
                var $item = $.getElement(" .category-item[data-ingredientId='" + item.IngredientId + "']", $wrapper);
                if ($item.length > 0) {
                    wrapper.showErrorMessage($item, item.ErrorCodes[0], null, null, null);//<--- fix to multiple errors
                    $item.addClass("tooltip-info-wrapper");
                    intiTooltip($item);
                };
            });
        };

        wrapper.showSummary = function (show) {
            if (show) $.getElement(' li.category:not(.summary-category-error)', $wrapper).removeClass("disabled");
            if (wrapper.config.SaveToDatabase || wrapper.config.ShareConfiguration || wrapper.config.PdfExport || wrapper.config.SendToOneDealer) {
                if (!wrapper.config.SaveToDatabase || !wrapper.model.CanEdit) $.getGlobalElement(".button-summary-wrapper .save-for-later-container", $wrapper).remove();
                if (!wrapper.config.ShareConfiguration) $.getGlobalElement(".button-summary-wrapper .share-container", $wrapper).remove();
                if (!wrapper.config.PdfExport) $.getGlobalElement(".button-summary-wrapper .download-pdf-container", $wrapper).remove();
                if (!wrapper.config.SendToOneDealer) $.getGlobalElement(".button-summary-wrapper .one-dealer-container", $wrapper).remove();
                $(".button-summary-wrapper").toggleClass("hidden", !show);
            }
            $(".recipe-buttons-container").toggleClass("hidden", !show);
            $(".js-full-screen-popup").toggleClass("disabled", !show);
            if (!wrapper.config.isConfigurationPage) {
                $(".configurator-container").toggleClass("hidden", show);
                $(".summary-container").toggleClass("hidden", !show);
            }
        };

        wrapper.initialize = function () {

            wrapper.model.CanEdit = true;

            if (wrapper.config.isConfigurationPage) {
                wrapper.model.RecipeItemId = pasrseInt(getQueryStringValueByName("ParentItemId") || "");
            }

            var vendd = getParentOrSelfVendd();

            var getUserViewModelSuccess = function () {

                wrapper.model.LoginPage = LhApp.Url.Page.Login + "?returnUrl=" + encodeURI(window.location);

                var globalId = getQueryStringValueByName("GlobalId") || "";
                var doSave = (getQueryStringValueByName("DoSave") || "") === "true";
                var callback = {}, config = {};
                if (wrapper.model.isAuthenticated && wrapper.config.SaveToDatabase && globalId !== "" && doSave) {
                    callback = {
                        success: function (response) {
                            var $successHtml = $.getGlobalElement('.success-for-later-text', $wrapper);
                            var location = UpdateQueryString("DoSave", false);
                            $("#saved-url", $successHtml).val(location);
                            $.fancybox.open($successHtml, {
                                touch: false
                            });
                            //console.log("update successfully!");
                        }, error: function () {
                            //console.log("updating failed!");
                        }, finally: function () {
                        }
                    };
                    config = {
                        GlobalId: globalId
                    };
                    wrapper.assignConfigurationToUser(callback, config);
                }

                var hasPermissions = !wrapper.config.HasAuthorizedPage ||
                    (wrapper.model.isAuthenticated && wrapper.config.HasAuthorizedPage) ||
                    (globalId !== "" && wrapper.config.LoadFromDatabase) ||
                    wrapper.config.isConfigurationPage;

                if (wrapper.config.isSubRecipe) {
                    var _ingredients = ((Vendd.RecipeLibrary.GetModel(wrapper.config.ParentRecipeItemId).data || {}).Ingredients) || {};
                    var _model = (_.find(_ingredients, function (i) { return i.SubRecipeId === wrapper.config.RecipeId }) || {}).SubRecipe || {};
                    wrapper.model = _model;
                    wrapper.model.RecipeItemId = wrapper.model.ProductItemId || 0;
                    var result = Vendd.RecipeLibrary.GetModel(wrapper.model.RecipeItemId);
                    wrapper.model = $.extend({}, wrapper.model, result.data);
                    wrapper.initModel = $.extend(true, {}, wrapper.model);

                    callback = {
                        success: loadDataSuccess,
                        error: loadDataError
                    };
                    config = {
                        GlobalId: globalId || ""
                    };
                    wrapper.loadData(callback, config);
                    return;
                }

                if (hasPermissions) {
                    var attributes = wrapper.config.Attributes.split(",");
                    vendd.MessageBus.publishAsync(wrapper, new vendd.Recipe.Messages.GetModel(wrapper.config.RecipeItemId, path, attributes));
                    vendd.MessageBus.subscribe(vendd.Recipe.Messages.GetModelSuccess, wrapper, function (envelope) {
                        if (wrapper.config.isSubRecipe) return;
                        var recipeId = (envelope.message.data || {}).RecipeId || 0;
                        wrapper.model.RecipeId = recipeId;

                        var hasCategoryData = ((envelope.message.data || {}).Categories || []).length > 0;
                        if (($('.x-recipe-ingredients-wrapper.issubrecipe[data-recipe-id="' + wrapper.model.RecipeId + '"]').length > 0 && wrapper.config.RecipeId !== wrapper.model.RecipeId) || !hasCategoryData) return;
                        wrapper.model.RecipeItemId = (envelope.message.data || {}).ProductItemId || 0;
                        wrapper.model.ParentRecipeId = wrapper.config.ParentRecipeId;
                        wrapper.model.ParentRecipeItemId = wrapper.config.ParentRecipeItemId;
                        wrapper.model = $.extend({}, wrapper.model, envelope.message.data);
                        wrapper.model.IsAuthorized = true;

                        if (wrapper.config.isConfigurationPage) {
                            wrapper.model.RecipeItemId = parseInt(getQueryStringValueByName("ParentItemId") || "");
                            wrapper.model.vin = getQueryStringValueByName("Vin") || "";
                            wrapper.model.partnerId = parseInt(getQueryStringValueByName("PartnerId") || "");
                            wrapper.model.isValidConfigurationPage = wrapper.model.RecipeItemId !== 0 && wrapper.model.vin !== "" && wrapper.model.partnerId !== 0;
                            wrapper.model.isConfigurationPage = true;
                        }
                        var result = Vendd.RecipeLibrary.InitRecipe(wrapper.model, wrapper.model.RecipeItemId);
                        wrapper.model = $.extend({}, wrapper.model, result.data.recipe);
                        wrapper.initModel = $.extend(true, {}, wrapper.model);

                        var callback = {
                            success: loadDataSuccess,
                            error: loadDataError
                        };
                        var config = {
                            GlobalId: globalId || ""
                        };
                        wrapper.loadData(callback, config);
                        //Custom BJT
                        //    var result = Vendd.RecipeLibrary.GetRecipeItems(id);
                        //    var itemInfo = {
                        //        minQuantity: 1,
                        //        maxQuantity: 1,
                        //        quanta: 1
                        //    };
                        //    var recipeItems = [];
                        //    $.each(result.data.RecipeItems, function (i, el) { 
                        //        recipeItems.push( {
                        //            RecipeItemId: el.RecipeItemId,
                        //            ParentProductId: id,
                        //            Quantity: el.Quantity
                        //          } );
                        //    });
                        //    var enhancedInfo = { color: '', size: '', list: 'productDetails', colorId: null };
                        //    var vendd = getParentOrSelfVendd();
                        //    //Dirty fix, wait cart to clear first (pd.js)
                        //    setTimeout(function() {
                        //        vendd.MessageBus.publishAsync($wrapper.get(0), new vendd.Cart.Messages.Add(id, skuId, path, qty, '', extraAttributes, bundleItems, recipeItems, comboItems, itemInfo, enhancedInfo));
                        //    }, 3000);
                    });
                } else {
                    wrapper.model.IsAuthorized = false;
                    wrapper.initModel = $.extend(true, {}, wrapper.model);
                    wrapper.update();
                    wrapper.loading(false);
                }
            };
            if (window.localStorage && window.localStorage.getItem("CurrentUserModel")) {
                wrapper.model.isAuthenticated = (JSON.parse(window.localStorage.getItem("CurrentUserModel") || "")).IsAuthenticated || false;
                getUserViewModelSuccess();
            } else {
                vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, wrapper, function (envelope) {
                    wrapper.model.isAuthenticated = (((envelope.message || {}).data || {}).model || {}).IsAuthenticated || false;
                    getUserViewModelSuccess();
                });
            }

            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GetShippingModelSuccess, wrapper, function (envelope) {
                wrapper.shippingModel = (((envelope.message || {}).data || {}).model || {});
            });
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyShippingDataSuccess, wrapper, function (envelope) {
                wrapper.model.ShippingCost = parseFloat(stringToNumber(wrapper.shippingModel.ShippingCostText));
                wrapper.model.ShippingCostText = wrapper.shippingModel.ShippingCostText;
                $.getElement(' .summary-shipping-price', $wrapper).html(wrapper.model.ShippingCostText);
                //wrapper.setCheckedItems();
            });
        };

        wrapper.initialize();
    };

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'x-recipe-ingredients-wrapper', function (envelope) {
        bindRecipeController();
    });

    var bindRecipeController = function () {
        $('.x-recipe-ingredients-wrapper').each(function () {

            recipeController($(this), configuratorOptions);
        });

        $.getGlobalElement('.js-show-recipe', $wrapper).off('click').on('click', function (e) {
            var $parent = $(this).closest('.x-recipe-ingredients-wrapper');
            if ($parent.length === 0) return;
            recipeController($parent, configuratorOptions);
        });

    };

    $('.x-recipe-ingredients-wrapper').each(function () {

        recipeController($(this), configuratorOptions);
    });
});

function copyToClipboard() {
    copyText = document.getElementById("saved-url");

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /*For mobile devices*/

    /* Copy the text inside the text field */
    document.execCommand("copy");
}


function numberToString2(value, addCurrency, clearZeros) {
    var returnValue, currency, decimal, fractional;

    currency = LhApp.Context.Currency.Symbol;
    var doShowSymbol = LhApp.Context.Currency.DoShowSymbol;
    var symbolShownFirst = LhApp.Context.Currency.SymbolShownFirst;
    var decimalSeperator = LhApp.Context.Currency.DecimalSeparator;
    var thousandSeperator = LhApp.Context.Currency.DecimalSeparator === "." ? "," : ".";
    var numberOfDigits = LhApp.Context.Currency.NumberOfDigits;

    returnValue = parseFloat(value).toFixed(numberOfDigits);
    returnValue += "";
    returnValue = returnValue.replace('.', decimalSeperator).trim();

    if (clearZeros) {
        fractional = returnValue.split(decimalSeperator);

        if (fractional.length > 1) {
            if (new RegExp("^[0\0]+$").test(fractional[1])) {
                returnValue = fractional[0];
            }
        }
    }
    returnValue = returnValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandSeperator);

    if (addCurrency && doShowSymbol)
        returnValue = symbolShownFirst ? currency + " " + returnValue : returnValue + " " + currency;

    return returnValue;
}
function getShortenedUrlAuth() {
    return $.ajax({
        type: "POST",
        dataType: 'json',
        async: false,
        contentType: 'application/json; charset=UTF-8',
        url: "services/api/ExternalServices/GetShortenedUrlAuth",
        data: null
    });
}
function getShortenedUrl(url) {
    return $.when(getShortenedUrlAuth()).done(function (response) {
        // the code here will be executed when all four ajax requests resolve.
        // a1, a2, a3 and a4 are lists of length 3 containing the response text,
        // status, and jqXHR object for each of the four ajax calls respectively.
        var requestData = {
            "token": JSON.parse(response.message).access_token,
            "url": url
        };
        return $.ajax({
            type: "POST",
            dataType: 'json',
            async: false,
            contentType: 'application/json; charset=UTF-8',
            url: "services/api/ExternalServices/GetShortenedUrl",
            data: JSON.stringify(requestData),
            success: function (response) {
                shortUrl = JSON.parse(response.message)[0].shortFormat;
                var confUrl = window.location.href;
                if (shortUrl) {
                    confUrl = shortUrl;
                }
                $('.js-pdf-footer .shorturl').attr('href', confUrl).text(confUrl);
                generateQr(confUrl);
            },
            error: function () {
                $(".qr-wrapper").html(
                    '<img scr="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" width="1" height="1" />'
                );
            }
        });
    });
}
function generateQr(url) {
    $(".qr-wrapper img").remove();
    var $qrWrapper = $(".qr-wrapper");
    new QRCode($qrWrapper[0], {
        text: url,
        width: 120,
        height: 120
    });
    $(".qr-wrapper .qr-literal").css('color', '#4999CE');
}
